export default "__VITE_ASSET__3718559a__"